export default __webpack_public_path__ + "static/media/jj_logos_separate.1611aa8e.png";